import cookie from "react-cookies";
import { getBackendUrl, subdomain } from "../auth/utilities";

/**
 * Common API fetch wrapper for standalone OTP portal requests.
 * Mirrors the main app's fetchData behavior, using local config.
 */
export default async function fetchData(endpoint, options = {}) {
  // Construct URL dynamically
  const backendUrl = getBackendUrl();
  const sub = subdomain;
  
  // E.g., /api/subdomain/en/tprm/...
  // Many vendor API paths start directly from 'tprm/', but `buildTenantApiUrl` format is `api/${sub}/en/`.
  // Since vendorApiService sends `tprm/...`, we simply append it.
  const url = `${backendUrl}${sub}/en/${endpoint}`;
  
  const csrfToken = cookie.load("csrftoken");
  
  const headers = {
    ...options.headers,
  };
  
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }
  
  if (options.method && options.method.trim().toUpperCase() !== "GET") {
    headers["X-CSRFToken"] = csrfToken;
  }

  const res = await fetch(url, {
    ...options,
    credentials: "include",
    headers,
    body: options.body instanceof FormData ? options.body : (options.body ? JSON.stringify(options.body) : undefined)
  });
  
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || "Request failed");
  }
  return await res.json();
}
